module.exports = __webpack_public_path__ + "img/1.acf71f57.svg";